import { render, staticRenderFns } from "./navbar-boost-view-menu.vue?vue&type=template&id=dcacb0ca&scoped=true&"
import script from "./navbar-boost-view-menu.vue?vue&type=script&lang=ts&"
export * from "./navbar-boost-view-menu.vue?vue&type=script&lang=ts&"
import style0 from "./navbar-boost-view-menu.vue?vue&type=style&index=0&id=dcacb0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcacb0ca",
  null
  
)

export default component.exports